import styled from 'styled-components';
import ReactModalAdapter from './ReactModalAdapter';
import PrimaryButton from '../PrimaryButton';
import { colors, MediaQuery } from '../../../theme/style-helpers';

export const ModalContainer = styled.div`
  display: grid;
`;

export const ModalContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 0px 23px;

  ${MediaQuery.small`
    padding: 0px 48px;
  `}
`;

export const ModalHeader = styled.div`
  font-size: 24px;
  font-weight: 500;
  line-height: 31px;
  text-align: center;

  ${MediaQuery.small`
    font-size: 28px;
    line-height: 36px;
  `}
`;

export const ModalContent = styled.div`
  width: 100%;
  font-size: 13px;
  text-align: center;
`;

export const ModalActions = styled.div`
   padding: 0;
`;

export const ModalFooter = styled.div`
  text-align: center;
`;

export const ModalCloseButton = styled.button`
  justify-self: flex-end;
  border: none;
  background: none;
  font-size: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0px;
  margin: 15px;
  transition: background-color 0.4s;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: #EEE;
  }

  ${MediaQuery.small`

  `}
`;

export const ActionButton = styled(PrimaryButton)`
  width: 166px;
`;

const MAX_Z_INDEX = 10000;

export const StyledModal = styled(ReactModalAdapter)`
  &__overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${({ maximizeZIndex }) => (maximizeZIndex ? MAX_Z_INDEX : 'unset')};
    padding-top: ${({ marginTop }) => marginTop};
    background-color: rgba(0, 0, 0, 0.8);

    ${MediaQuery.xSmall`
      padding-top: 0;
    `}
  }

  &__content {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 4px;
    background-color: ${colors.LIGHT_GREY};
    padding: 0 0 30px;
    z-index: 10;

    ${MediaQuery.small`
      width: 648px;
      height: unset;
    `}
  }
`;
